import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type SupplierDetailResponse } from '../types';
import { zodSupplierDetailResponseSchema } from '../validations';

import { type UpdateSupplierRelationshipPayload } from './types';
import { zodUpdateSupplierRelationshipPayloadSchema } from './validations';

/**
 * Updates relationship fields for a supplier by its data exchange ID.
 *
 * Only the included fields are patched (PATCH semantics).
 *
 * @param deId - The data exchange ID of the supplier relationship.
 * @param payload - The fields to update.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The updated supplier detail response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Supplier-details/operation/update_supplier_relationship_suppliers_details__de_id__patch
 */
export const updateSupplierRelationship = async (
  deId: UUID,
  payload: UpdateSupplierRelationshipPayload,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .patch(ENDPOINT.SUPPLIER.UPDATE_RELATIONSHIP(deId), {
      json: payload,
      ...options,
      validate: {
        body: zodUpdateSupplierRelationshipPayloadSchema,
        response: zodSupplierDetailResponseSchema,
      },
    })
    .json<SupplierDetailResponse>();
